export const IP = 'api.permanencia-ascun.com';
//export const MAIN_API_HOST = `http://${IP}:9001`;
export const MAIN_API_HOST = `https://${IP}`;